import {Injectable, NgZone} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {SongEntity, TrackEntity} from '@spout/any-shared/models';
import {upsertDeviceStorage} from '@spout/web-global/actions';
import {currentIdSet, firestoreTrackByIdPath, mergeEntities} from '@spout/web-global/fns';
import {StudioAppState} from '@spout/web-global/models';
import {getTrackEntityByIdFn} from '@spout/web-global/selectors';
import {EMPTY, Observable, Observer} from 'rxjs';
import {switchMap, take} from 'rxjs/operators';
import {Exists, SptFirestoreService} from '../firestore';
import {DynamicStoreService} from '../services/dynamic-store.service';

@Injectable({
  providedIn: 'root'
})
export class FirestoreTracksService {
  constructor(
    private dss: DynamicStoreService,
    private sptFirestore: SptFirestoreService,
    private store: Store<StudioAppState>,
    private zone: NgZone
  ) {}

  createTrackFirestore(track: Partial<TrackEntity>): Observable<TrackEntity> {
    // console.log('CREATE TRACK', track-audio);
    const that = this;
    that.zone.run(() => {
      this.store.dispatch(
        upsertDeviceStorage({
          storage: {
            currentIds: currentIdSet(track)
          }
        })
      );
    });

    return new Observable((observer: Observer<any>) => {
      this.sptFirestore
        .setDocIfNotExist<SongEntity>(firestoreTrackByIdPath(track), track)
        .subscribe((r: Exists<SongEntity>) => {
          observer.next(r.data);
        });
    });
  }

  updateTrack(track: Partial<TrackEntity>): Observable<Exists<TrackEntity>> {
    if (track && track.id) {
      return this.store.pipe(
        select(getTrackEntityByIdFn({trackId: track.id})),
        take<TrackEntity | null | undefined>(1),
        switchMap((trackEntity: TrackEntity | null | undefined) => {
          let config;

          if (trackEntity) {
            config = mergeEntities(trackEntity, track);
          } else {
            config = track;
          }

          // console.log('trackEntity', config, firestoreTrackByIdPath(config));

          return this.sptFirestore.upsertDoc<TrackEntity>(firestoreTrackByIdPath(config), config);
        })
      );
    }

    return EMPTY;
  }

  upsertTrack(track: Partial<TrackEntity>): void {
    if (track && track.id) {
      this.store
        .pipe(select(getTrackEntityByIdFn({trackId: track.id})), take(1))
        .subscribe((trackEntity: TrackEntity | null | undefined) => {
          this.sptFirestore
            .setDocIfNotExist<SongEntity>(firestoreTrackByIdPath(track), track)
            .subscribe((r: Exists<SongEntity>) => {
              /* noop */
            });
        });
    }
  }

  deleteTrack(track: TrackEntity): void {
    this.sptFirestore.deleteDoc$(firestoreTrackByIdPath(track)).subscribe(
      () => {
        /* noop */
      },
      error => {
        /* noop */
      }
    );
  }
}
